// import { mapGetters } from "vuex";

export default {
  data() {
    return {
      actionResourceTypeOptions: [
        "Site",
        "Trade",
        "Technical",
        "Business",
        "Corporate",
        "General"
      ],
      actionType: [
        "Audit",
        "Business",
        "Corrective",
        "Feedback",
        "Order",
        "Risk Control",
        "Preventative",
        "Recommendation",
        "Study",
        "Task",
        "Technical"
      ],
      actionTheme: [
        "Authority",
        "Regulation",
        "Environment",
        "Health ",
        "Policy",
        "Production",
        "Reputation",
        "Safety",
        "Cost"
      ],
      // eslint-disable-next-line
      actionStatusOptions: [
        "In Progress",
        "Immplemented",
        "Removed",
        "NA"
      ],
      // eslint-disable-next-line
      actionPriority: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"],
      // eslint-disable-next-line
      actionTime: [
        "1D",
        "3D",
        "1W",
        "2W",
        "1M",
        "2M",
        "3M",
        "4M",
        "6M",
        "9M",
        "1Y"
      ]
    };
  }
};
